import React from 'react'
import { apiFetch } from '../../../fetchApi'

export const deleteExperience = ({ BeURL, id, candidateId, showAlert }) => {
    apiFetch(`${BeURL}/candidate-experience-delete/${id}/${candidateId}`, {
        method: "DELETE",
        credentials: 'include'
    })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                showAlert(data.message)
            }
            else {
                showAlert(data.message)
            }
        })
        .catch(err => {
            console.log("Error to Delete candidate experience", err)
        })
}
